// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609141507/js/" + chunkId + "." + {"44":"b30c28c2","225":"db1492e5","481":"8544c597","486":"1e932c36","770":"4174a9e8"}[chunkId] + ".0.04319080310057066.chunk.js";
};